<template>
    <div id="consent-box" class="card mb-25 border-0 rounded-0 bg-white letter-spacing flex-grow-1 overflow-y-auto">
        <!-- <div class="d-flex justify-content-center h-100 align-items-center" v-if="consent_details === undefined">
                    <SpinnerLoading class="h-auto"/>
                </div> -->
        <div class="card-body p-15 p-sm-20 p-md-25 " v-html="consent.current_version?.body"></div>
    </div>
    <div class="form-check form-group mb-15 mb-sm-20 mb-md-25" v-if="consent.current_version?.has_checkbox ?? false">
        <input class="form-check-input shadow-none" type="checkbox" v-model="accept" id="accept">
        <label class="form-check-label fw-medium position-relative top-1" for="accept">
            {{ consent.current_version?.checkbox_disclaimer ?? '' }}
        </label>
    </div>
    <!-- ERROR MESSAGE -->
    <div class="row justify-content-center">
        <div class="col">
            <div class="alert alert-danger alert-dismissible fade border-0 border-danger-subtle border-top rounded-0 m-0 mb-25"
                role="alert" id="errorMessage">
                <strong>{{ $t('error.something_went_wrong') }}</strong>
                <button type="button" class="btn-close" v-on:click="hideError" aria-label="Close"></button>
            </div>
        </div>
    </div>
    <div class="text-end mb-25">
        <button :disabled="!nextEnabled" v-on:click="initConsent()"
            class="default-btn transition fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 fs-md-15 fs-lg-16">
            <template v-if="!loading">
                {{ $t('cta.withdraw_consent') }}
            </template>
            <SpinnerLoading v-else :small="true" class="h-auto mb-0" />

        </button>
    </div>
    <AlertModal id="alertModal" :title="$t('cta.withdraw_consent')" :dismissible="false"
        :message="$t('feature.auth.$withdraw_consent.success_message')" @confirm="redirect" />
    <ConfirmModal id="confirmModal" :title="$t('cta.withdraw_consent')"
        :message="$t('feature.auth.$withdraw_consent.alert_message')" @confirm="submitConsent()" />
</template>
<style lang="scss">
#consent-box {
    h3 {
        font-size: 16px;
    }

    h4 {
        font-size: 14px;
        color: #000 !important;
    }

    table {
        margin-bottom: 1rem;

        th,
        td {
            border: 1px solid #606060;
            padding: .25rem .5rem;
        }

        tr {
            vertical-align: baseline;
        }

        p {
            margin-bottom: 0;
        }
    }
}
</style>

<script lang="ts">
import AlertModal from '@/components/Widgets/AlertModal.vue';
import ConfirmModal from '@/components/Widgets/ConfirmModal.vue';
import SpinnerLoading from '@/components/Widgets/Spinner.vue';
import API from '@/services/api/api.service';
import { Consent, ConsentVersion } from '@/utils/models/consent.model';
import { Alert, Modal } from 'bootstrap';
import { defineComponent } from 'vue';

export default defineComponent({
    name: "ConsentGrantPage",
    components: {
        AlertModal,
        ConfirmModal,
        SpinnerLoading,
    },
    mounted() {
        /* this.getConsents().finally(() => {
            this.addScrollListener();
        }); */
        this.errorMessage = new Alert('#errorMessage');
        this.alertModal = new Modal('#alertModal', {});
        this.confirmModal = new Modal('#confirmModal', {});
        this.addScrollListener();
    },
    unmounted() {
        this.removeScrollListener();
    },

    data() {
        return {
            index: 0,
            consent: this.$route.meta.consent as Consent,
            // consent_details: undefined as Consent[] | undefined,
            accept: false,
            scrolled_bottom: false,
            consent_box: undefined as HTMLElement | undefined,
            submitted: false,
            errorMessage: undefined as Alert | undefined,
            errors: undefined as any,
            alertModal: null as Modal | null,
            confirmModal: null as Modal | null,
            loading: false,
        }
    },

    computed: {
        accepted(): boolean { return ((this.consent.current_version?.has_checkbox ?? false) && (this.consent.current_version?.mandatory ?? false)) ? this.accept : true },
        nextEnabled(): boolean { return (this.consent.current_version?.text_scroll ?? false) ? this.accepted && this.scrolled_bottom : true },
    },
    methods: {
        /* async getConsents() {
            return Promise.all(this.consents!.map((consent) => API.getConsent(consent.id!))).then((responses) => {
                this.consent_details = (responses?.map((res) => res.data.data) ?? []).flat();
            })
        }, */
        removeScrollListener() {
            if (this.consent_box !== undefined && this.consent_box !== null) {
                console.log('remove_scroll_listener');
                this.consent_box.removeEventListener('scroll', this.checkScroll);
            }
        },
        addScrollListener() {
            setTimeout(() => {
                this.scrolled_bottom = false;
                this.consent_box = document.getElementById('consent-box')!;
                this.consent_box.scrollTop = 0;
                console.log('add_scroll_listener');
                this.consent_box.addEventListener('scroll', this.checkScroll);
                this.checkScroll(null);
            }, 10)
        },
        checkScroll(event) {
            if (this.consent_box !== undefined && (Math.ceil(this.consent_box!.scrollTop + this.consent_box!.offsetHeight) >= this.consent_box!.scrollHeight)) {
                console.log('scrolled_bottom');
                this.scrolled_bottom = true;
                this.removeScrollListener();
            }
        },
        nextConsent() {
            this.index++;
            this.accept = false;
            this.removeScrollListener();
            this.addScrollListener();
        },
        initConsent() {
            this.confirmModal?.show();
        },
        submitConsent() {
            this.loading = true;
            API.registerUserConsent({
                version_id: this.consent.current_version?.id!,
                action: 'revoke',
            }).then((res) => {
                if (res.data.success === true) {
                    this.alertModal?.show();
                } else {
                    this.loading = false;
                    this.showError();
                }
            }).catch((error) => {
                this.loading = false;
                console.error('REGISTER_CONSENT_ERROR')
            })

        },
        showError() {
            const error = document.getElementById('errorMessage');
            error?.classList.add('show');
            setTimeout(() => {
                this.hideError();
            }, 5000)
        },
        hideError() {
            const error = document.getElementById('errorMessage');
            error?.classList.remove('show');
        },
        redirect() {
            this.$router.push('/logout');
        },
    }
});
</script>